import { ShiftTime } from './shift-time.model';

export class ShiftRequest {
    public userId: number;
    public dates: ShiftTime[];
    public startDate: Date;
    public endDate: Date;
    public description: string;
}
